import React from "react";
import Btn from "../Btn/Btn";
import { GrUserSettings } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import { BiCategoryAlt } from "react-icons/bi";
import { useMainContext } from "../../Context";

const Categoires = ({ data }) => {
  const { dispatch } = useMainContext();
  const navigate = useNavigate();
  return (
    <div>
      {" "}
      <div className="category">
        {data.map(item => {
          return (
            <button
              to={`/list?category_id=${item.id}`}
              className={"categoriesBtn"}
              onClick={() => {
                dispatch("parent_Category", item);
                localStorage.setItem("isParent", true);
                navigate("/list");
              }}
            >
              <div className="d-flex justify-content-center">
                {item?.image?.url ? (
                  <img src={item?.image?.url} />
                ) : (
                  <BiCategoryAlt />
                )}
              </div>
              <div className="text-category-wrapper">
                <p className="text  fs-10">{item.title}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Categoires;
